import { Box } from '@mui/material';


export const NavigationLinks: React.FC = ({ children }) => (
  <Box
    display="flex"
    gap="14px"
  >
    {children}
  </Box>
);
